module.exports = __webpack_public_path__ + "static/img/main_txt_01.509824d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/main_txt_01.png
// module id = BwpV
// module chunks = 1